import React from "react";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import Image from "./Image";

const FeatureCard = ({ featureData }) => {
  const { header, icon, description, url } = featureData;

  return (
    <div
      className="
        w-full md:max-w-[394px]
        min-h-[222px]  h-full
        rounded-[16px] p-4 flex flex-col gap-4
        bg-card-gradient backdrop-blur-[50px] border border-white/60
      ">
      <Image src={icon} alt={header} width="40" height="40" />
      <div className="flex flex-col justify-between flex-1">
        <div className="flex flex-col gap-2 mt-2">
          <div className="text-cf-hero font-inter text-[16px] font-semibold leading-[30px]">
            {header}
          </div>
          <p className="font-inter text-[14px] font-normal leading-[24px]">
            {description}
          </p>
        </div>
        <Link
          to={url}
          className="font-inter text-[14px] font-semibold leading-[24px] text-cf-primary pt-2">
          Learn More »
        </Link>
      </div>
    </div>
  );
};

FeatureCard.propTypes = {
  featureData: PropTypes.shape({
    header: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default FeatureCard;
